/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiAddress } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of MandantInfoController.
 */
export class MandantInfoRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /mandanten/{mandantId}/address
     */
    public getAddress(mandantId: string): Promise<Result<ApiAddress>> {
        return this.http.get<Result<ApiAddress>>(`/mandanten/${mandantId}/address`);
    }

    /**
     * Calls GET /mandanten/entitlements
     */
    public getEntitlements(): Promise<Result<Record<string, string>>> {
        return this.http.get<Result<Record<string, string>>>('/mandanten/entitlements');
    }
}
